import { render, staticRenderFns } from "./GDPR.vue?vue&type=template&id=cab191d4&scoped=true"
import script from "./GDPR.vue?vue&type=script&lang=js"
export * from "./GDPR.vue?vue&type=script&lang=js"
import style0 from "./GDPR.vue?vue&type=style&index=0&id=cab191d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab191d4",
  null
  
)

export default component.exports